import './index.css'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './routes/AppRoutes'
import { inject } from '@vercel/analytics'
import { StrictMode } from 'react'
import { Provider } from 'react-redux'
import { store } from './store/store'
import Gleap from 'gleap'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.echow\.app/],
  environment: process.env.REACT_APP_ENVIRONMENT,
  release: 'echow-admin-frontend@' + process.env.npm_package_version,
})

// Enable Vercel analytics
inject({
  mode:
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? 'production'
      : 'development',
})

//Gleap init
if (process.env.REACT_APP_GLEAP_PROJECT_ID) {
  Gleap.initialize(process.env.REACT_APP_GLEAP_PROJECT_ID)
  Gleap.setEnvironment(
    process.env.REACT_APP_ENVIRONMENT === 'production' ? 'prod' : 'staging'
  )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <BrowserRouter basename="/">
      <Provider store={store}>
        <AppRoutes />
      </Provider>
    </BrowserRouter>
  </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
